export const PAYMENTATTEMPT_STATUS = {
    CANCELED: "CANCELED",
    DELIVERED: "DELIVERED",
    EXPIRED: "EXPIRED",
    FAILED: "FAILED",
    NEW: "NEW",
    PAID: "PAID",
    REFUNDED: "REFUNDED"
};